import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromConfirmation from './state/confirmation.reducer';
import { ConfirmationFacade } from './state';
import { ConfirmationDirective } from './confirmation.directive';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromConfirmation.CONFIRMATION_FEATURE_KEY, fromConfirmation.reducer),
    ConfirmationDirective
  ],
  providers: [ConfirmationFacade],
  declarations: [],
  exports: [ConfirmationDirective]
})
export class ConfirmationFeatureModule {}
